import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class AttendanceAPI extends API {
	putAttendance(data) {
		const newObj = JSON.stringify({ asistencias: data });
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/put/`,
				data: newObj,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const attendanceAPI = new AttendanceAPI('/asistencia');
